module.exports = __webpack_public_path__ + "static/media/5.78f3174a.png";